export default "__VITE_PUBLIC_ASSET__af887a50__"